import { getUnsuspendPageUrl } from '../../utils/siteUrls';

import { getCurrentLang } from 'react-redux-app/lib/modules/i18n/selectors';
import { getIsActive } from '../../../auth/selectors';


// Note: auth is required
export default ({ getState, dispatch }) => (
  function activeRequiredHandler(nextState, successCallback, errorCallback) {
    const isUserActive = getIsActive(getState());
    if (isUserActive) {
      successCallback();
    } else {
      errorCallback(getUnsuspendPageUrl(getCurrentLang(getState())));
    }
  }
);
